import { useState } from "react";
import { Container, Input, Row, Table } from "reactstrap";
import Tableth from "./TableRow";

const JsGridTable = () => {
  const [isSwitchSearch, setIsSwitchSearch] = useState(false);

  const switchSearchHandler = () => {
    setIsSwitchSearch((isSwitchSearch) => !isSwitchSearch);
  };
  const divStyle = {
   with:'150px',
   
  };
  return (
    <>
      <div className="page-body">
        <Container fluid>
          <Row>
            <div className="card">
              <div className="card-header pb-0">
                <h2 className="mb-3">Basic Scenario</h2>
                <p className="f-m-light mt-1">
                  Grid with filtering, editing, inserting, deleting, sorting and
                  paging. Data provided by controller.
                </p>
              </div>
              <div className="card-body">
                <div
                  className="basic_table customTable_wrapper"
                  id="basicScenario"
                >
                  <div className="jsgrid-grid-header jsgrid-header-scrollbar">
                    <Table bordered responsive className="jsgrid-table">
                      <thead className="">
                        <tr className="jsgrid-header-row">
                          <th className="jsgrid-header-cell jsgrid-header-sortable" style={{ width: 100 }}>
                            Task
                          </th>
                          <th className="jsgrid-header-cell jsgrid-header-sortable" style={{ width: 100 }}>
                            Eamil
                          </th>
                          <th className="jsgrid-header-cell jsgrid-header-sortable" style={{ width: 107 }}>
                            Phone
                          </th>
                          <th className="jsgrid-header-cell jsgrid-header-sortable" style={{ width: 60 }}>
                            Assign
                          </th>
                          <th className="jsgrid-header-cell jsgrid-header-sortable" style={{ width: 70 }}>
                            Date
                          </th>
                          <th className="jsgrid-header-cell jsgrid-header-sortable" style={{ width: 100 }}>
                            Price
                          </th>
                          <th className="jsgrid-header-cell jsgrid-header-sortable" style={{ width: 70 }}>
                            Status
                          </th>
                          <th className="jsgrid-header-cell jsgrid-header-sortable" style={{ width: 50 }}>
                            Progress
                          </th>
                          <th className="jsgrid-header-cell jsgrid-control-field jsgrid-align-center" style={{ width: 70 }}>
                            <div className="jsgrid-align-center">
                              <div className="align-items-center d-flex gap-2 justify-content-center ">
                                <Input
                                  onClick={switchSearchHandler}
                                  className={`jsgrid-button jsgrid-mode-button ${
                                    isSwitchSearch
                                      ? "jsgrid-search-mode-button"
                                      : "jsgrid-insert-mode-button" 
                                  }`}
                                  type="button"
                                  title={`${
                                    isSwitchSearch
                                      ? "Switch to searching"
                                      : "Switch to inserting"
                                  }`}
                                />
                              </div>
                            </div>
                          </th>
                        </tr>
                        
                      </thead>
                      <tbody>
                      {!isSwitchSearch ? 
                        <tr className="jsgrid-filter-row">
                          <td className="jsgrid-cell">
                            <Input id="1" name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>

                          <th className="jsgrid-cell jsgrid-control-field jsgrid-align-center">
                            <div className="jsgrid-align-center">
                              <div className="align-items-center d-flex gap-2 justify-content-center ">
                                <Input
                                  type="button"
                                  className="jsgrid-button jsgrid-search-button"
                                  title="Search"
                                />
                                <Input
                                  type="button"
                                  className="jsgrid-button jsgrid-clear-filter-button"
                                  title="Clear filter"
                                />
                              </div>
                            </div>
                          </th>
                        </tr>
                        :
                        <tr className="jsgrid-insert-row">
                          <td className="jsgrid-cell">
                            <Input id="1" name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>
                          <td className="jsgrid-cell">
                            <Input name="text" type="text" />
                          </td>

                          <td className="jsgrid-cell jsgrid-control-field jsgrid-align-center">
                            <div className="jsgrid-align-center">
                              <div className="align-items-center d-flex gap-2 justify-content-center ">
                                <Input
                                  type="button"
                                  className="jsgrid-button jsgrid-insert-button"
                                  title="Search"
                                />
                                
                              </div>
                            </div>
                          </td>
                        </tr>
                        }
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />
                        <Tableth
                          initialTask={"Wordpress"}
                          initialEmail={"Pixel@efo.com"}
                          initialPhone={"+91 9152639845"}
                          initialAssign={"Otto Clay"}
                          initialDate={"26/09/2023"}
                          initialPrice={"$2315.00"}
                          initialStatus={"In progress"}
                          initialProgress={"100%"}
                        />

                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default JsGridTable;
